import * as React from 'react';
import '../../context/actions.js';
import '../../context/reducer.js';
import '../../types/product.js';
import '../../context/ProductContext.js';
import { useCmsData } from '../../context/CmsContext.js';
import { ProductDetailUsps } from './ProductDetailUsps.js';

const ProductDetailUspsContainer = ({ children , className ,  })=>{
    const { usps  } = useCmsData();
    return /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: usps,
        className: className
    }, children);
};

export { ProductDetailUspsContainer };
//# sourceMappingURL=ProductDetailUspsContainer.js.map
